import { Avatar, AvatarProps, Stack, Box, Typography, lighten } from '@mui/material';
import React, { ReactElement } from 'react';

const avatarSx: AvatarProps['sx'] = ({ spacing, palette }) => ({
  width: spacing(3),
  height: spacing(3),
  bgcolor: lighten(palette.primary.light, 1 - 0.1),
});

type Props = {
  listValues: string[];
};
const NumberedList: React.FC<Props> = ({ listValues }: Props): ReactElement => {
  return (
    <Stack spacing={2}>
      {listValues.map((value, index) => {
        return (
          <Box key={`list-index-${index}`} display="flex" alignItems="center" color="text.secondary">
            <Avatar sx={avatarSx}>
              <Typography variant="body2" color="primary">
                {index + 1}
              </Typography>
            </Avatar>
            <Typography variant="caption" ml={1}>
              {value}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};

export { NumberedList };
